module.exports = __webpack_public_path__ + "img/bj_tan.a48f879e.png";